import { postAPI } from 'framework/api/http';
import { useMutation } from 'react-query';

interface DeleteVideoInterface {
  video: string;
  status: string;
}

export const useSendVideoDeletionRequest = () => {
  const mutate = useMutation(({ video, status }: DeleteVideoInterface) => {
    return postAPI('/media-api/send_deletion_request', {
      vid: video,
      status,
    });
  });

  return mutate;
};

export default useSendVideoDeletionRequest;
